<template>
 <div>
    <div class="el-table el-table--fit el-table--border inner-table" style="border-top: none !important; border-left: none !important">
            <div class="el-table__body-wrapper">
                <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                    <tbody>
                        <tr>
                                <td colspan="6" style="position: relative;">
                                    <span style="display: inline-block;margin-left: 45%;color: #333333; font-weight: bold">采购公告信息</span>
                                    <el-button v-if="canEdit==1" style="position: absolute;right: 5px;" @click="add()">添加标包</el-button>
                                </td>
                            </tr>
                    </tbody>
                </table>
            </div>
        </div>
    <el-form :model="vo" class="el-form wflow-busiform">
            <div class="el-table el-table--fit el-table--border" style="border-top: none !important;border-left: none !important;">
                <div class="el-table__body-wrapper">
                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body listTable">
                        <tbody>
                            <!-- <tr>
                                <td colspan="6" style="position: relative;">
                                    <span style="display: inline-block;margin-left: 45%;color: #333333; font-weight: bold">采购公告信息</span>
                                    <el-button v-if="canEdit==1" style="position: absolute;right: 5px;" @click="add()">添加标包</el-button>
                                </td>
                            </tr> -->
                            <tr>
                                <td id="tdw17" ref="tdlbl_项目名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'flSubject'" class="field">发布日期</span>
                                </td>
                                <td v-if="vo.cgPublicDate || vo.cgPublicDate==null" class="el-table__cell tdcont tdw33" colspan="2">
	          				<form-item ref="cgPublicDate" :field="{'defaultValue':null,'elementCanEdit':'{${curTN.tnCanEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':1,'elementType':'date','emptyMessage':'请选择发布日期','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'发布日期','propName':'cgPublicDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd HH:mm','valueMaxLength':null,'valueMinLength':null,'model':'vo.cgPublicDate','option':[]}" :vo="vo" :can-edit="canEdit" />
	                </td>
                    <td v-else class="el-table__cell tdcont tdw33" colspan="2">
	          				<form-item ref="publicDate" :field="{'defaultValue':null,'elementCanEdit':'{${curTN.tnCanEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':1,'elementType':'date','emptyMessage':'请选择发布日期','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'发布日期','propName':'publicDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd HH:mm','valueMaxLength':null,'valueMinLength':null,'model':'vo.publicDate','option':[]}" :vo="vo" :can-edit="canEdit" />
	                </td>
                                <td ref="tdlbl_项目名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'flSubject'" class="field">标包数量</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
	          				<form-item ref="bidPackageCount" :field="{'defaultValue':null,'elementCanEdit':'{${curTN.tnCanEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入标包数量','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'标包数量','propName':'bidPackageCount','propType':'java.math.BigDecimal','textFormatter':'integer','valueMaxLength':null,'valueMinLength':null,'model':'vo.bidPackageCount','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}" :vo="vo" :can-edit="canEdit" />
	                </td>
                            </tr>
                            <template v-for="(item,index) in vo.passenger.cgItemList">
                            <tr :key="index + '-index'">
                                <td class="el-table__cell tdcont tdw83" colspan="6">
                                    <span>标包信息{{ index + 1 }}</span>
                                    <el-button v-if="canEdit==1" style="position: absolute;right: 5px;color: #f67f6c;" type="text" @click="deleteBb(index)">删除标包</el-button>
                                </td>
                            </tr>
                            <tr :key="index + '-main'">
                                 <td ref="tdlbl_项目名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'flSubject'" class="field">标包号</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
	          				<form-item ref="contactPerson" :field="{'defaultValue':null,'elementCanEdit':'{${curTN.tnCanEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入标包号','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'标包号','propName':'bidPackageCode','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'item.bidPackageCode','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}" :vo="item" :can-edit="canEdit" />
	                </td>
                                <td ref="tdlbl_项目名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'flSubject'" class="field">文件售价(元)</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="2">
	          				<form-item ref="contactPerson" :field="{'defaultValue':null,'elementCanEdit':'{${curTN.tnCanEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入文件售价','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'文件售价','propName':'filePrice','propType':'java.math.BigDecimal','textFormatter':'integer','valueMaxLength':null,'valueMinLength':null,'model':'item.filePrice','option':[],'autocomplete':'off','dialog':0,'showWordLimit':false}" :vo="item" :can-edit="canEdit" />
	                </td>
                            </tr>
                            <tr :key="index + '-sub'">
                                <td ref="tdlbl_项目名称" class="el-table__cell tdlbl tdw17" colspan="1">
                                    <span class="required">*</span>
                                    <span v-field-lbl="'flSubject'" class="field">开标日期</span>
                                </td>
                                <td class="el-table__cell tdcont tdw33" colspan="5">
	          				<form-item ref="openBidDate" :field="{'defaultValue':null,'elementCanEdit':'{${curTN.tnCanEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':1,'elementType':'date','emptyMessage':'请选择开标日期','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'开标日期','propName':'openBidDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd HH:mm','valueMaxLength':null,'valueMinLength':null,'model':'item.openBidDate','option':[]}" :vo="item" :can-edit="canEdit" />
	                </td>
                            </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-form>

 </div>
</template>

<script>
export default {
    components: {

    },
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        module: { type: String, default: null },
        baseUrl: { type: String, default: null },
        listName: { type: String, default: null },
        isHttp: { type: Boolean, default: true }
    },
    data() {
        return {
            moduleInfo: {}
        }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    beforeDestroy() {

    },
    mounted() {
    },
    methods: {
        add() {
            this.vo.passenger.cgItemList.push({
                'openBidDate': null,
                'filePrice': '',
                'bidPackageCode': ''
            })
        },
        deleteBb(index) {
            this.vo.passenger.cgItemList.splice(index, 1)
        }
    }
}
</script>

<style scoped lang="scss">
</style>
